<template>
  <el-card class="position-absolute model-edit-tool" :style="{ height: height, top: top }">
    <div slot="header" class="d-flex flex-row-between">
      <span class="fz-14">模型编辑</span>
      <span class="iconfont icon-close r cur_pointer fz-12" @click="closeComponent"></span>
    </div>
    <div class="tool-content h-100 fz-12 p-10">
      <el-row :gutter="10" type="flex" align="middle">
        <el-col :span="4">对象编码</el-col>
        <el-col :span="20"
          ><el-input v-model="currentTagCode" placeholder="对象编码" size="small"></el-input
        ></el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="middle" class="m-t-10">
        <el-col :span="4">模型工具</el-col>
        <el-col :span="20">
          <i
            class="iconfont icon-yxr-py fz-20 m-r-20 cur_pointer"
            :class="{ 'text-color-blue': editType === 1 }"
            @click="setEditType(1)"
          ></i>
          <i
            class="iconfont icon-refresh fz-20 m-r-20 cur_pointer"
            :class="{ 'text-color-blue': editType === 2 }"
            @click="setEditType(2)"
          ></i>
          <i
            class="iconfont icon-fullscreen1 fz-20 cur_pointer"
            :class="{ 'text-color-blue': editType === 3 }"
            @click="setEditType(3)"
          ></i>
        </el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="middle" class="m-t-10">
        <el-col :span="2">位置</el-col>
        <el-col :span="1"><span>X</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localTranslation[0]"
            size="mini"
            class="w-100"
            @change="changeLocalTranslation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Y</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localTranslation[1]"
            size="mini"
            class="w-100"
            @change="changeLocalTranslation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Z</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localTranslation[2]"
            size="mini"
            class="w-100"
            @change="changeLocalTranslation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>m</span></el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="middle" class="m-t-10">
        <el-col :span="2">旋转</el-col>
        <el-col :span="1"><span>X</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localRotation[0]"
            size="mini"
            class="w-100"
            @change="changeLocalRotation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Y</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localRotation[1]"
            size="mini"
            class="w-100"
            @change="changeLocalRotation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Z</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localRotation[2]"
            size="mini"
            class="w-100"
            @change="changeLocalRotation"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>°</span></el-col>
      </el-row>
      <el-row :gutter="10" type="flex" align="middle" class="m-t-10">
        <el-col :span="2">比例</el-col>
        <el-col :span="1"><span>X</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localScaling[0]"
            size="mini"
            class="w-100"
            @change="changeLocalScaling"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Y</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localScaling[1]"
            size="mini"
            class="w-100"
            @change="changeLocalScaling"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>Z</span></el-col>
        <el-col :span="6"
          ><el-input-number
            v-model="localScaling[2]"
            size="mini"
            class="w-100"
            @change="changeLocalScaling"
            controls-position="right"
          ></el-input-number
        ></el-col>
        <el-col :span="1"><span>%</span></el-col>
      </el-row>
    </div>
    <div class="card-footer p-l-10 p-r-10 p-b-10">
      <el-row class="w-100">
        <el-col :span="18">
          <el-button
            type="warning"
            class="iconfont icon-app-update"
            size="mini"
            :disabled="resetDisable"
            @click="resetCommand"
            >重置</el-button
          >
          <el-button
            type="info"
            size="mini"
            class="iconfont icon-pc-back"
            @click="undoCommand"
            :disabled="undoDisable"
            >撤销</el-button
          >
          <el-button
            type="success"
            size="mini"
            class="iconfont icon-pc-next"
            @click="redoCommand"
            :disabled="redoDisable"
            >重做</el-button
          >
        </el-col>
        <el-col :span="6" class="tr">
          <el-button type="primary" size="mini" @click="saveEngineerData" :loading="saveLoading"
            >保存</el-button
          >
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'
import { CommandManage } from '../../js/commandManage'
import { saveSceneToJson, isJSONObj, loadSceneFromJson } from '../../js/engineerSceneData'

export default {
  name: 'ModelEditTool',
  props: ['documentId', 'player', 'height', 'top', 'currentNodeData', 'watchNodeModify'],
  data() {
    return {
      currentTagCode: '',
      localTranslation: [0, 0, 0], // 位置变换
      localRotation: [0, 0, 0], // 旋转变换
      localScaling: [1, 1, 1], // 缩放变换
      commandManage: null,
      changeTimerOut: null,
      editType: 0, // 编辑方式
      saveLoading: false,
    }
  },
  watch: {
    currentNodeData: {
      async handler(val, oldVal) {
        if (val.nodePtr && val.nodePtr !== oldVal.nodePtr) {
          this.currentTagCode = val.name
          this.localTranslation = await this.player.Native.NodeProxy.localTranslation(val.nodePtr)
          const quat = await this.player.Native.NodeProxy.localRotation(val.nodePtr)
          // PlayerUtil公用方法
          this.localRotation = EulerAngle.fromQuat(quat)
          this.localScaling = await this.player.Native.NodeProxy.localScaling(val.nodePtr)
          this.commandManage = new CommandManage({
            localTranslation: _.cloneDeep(this.localTranslation),
            localRotation: quat,
            localScaling: _.cloneDeep(this.localScaling),
          })
          await this.player.Native.NodeEditor.setNode(val.nodePtr)
        }
      },
      deep: true,
    },
    async watchNodeModify(val) {
      if (val) {
        console.log(val)
        if (this.currentNodeData.nodePtr) {
          this.currentNodeData = await this.player.Native.NodeProxy.getNodeInfo(
            this.currentNodeData.nodePtr
          )
          this.currentTagCode = this.currentNodeData.name
        }
      } else {
        this.currentTagCode = ''
        this.currentNodeData = {}
      }
    },
  },
  async created() {
    if (this.currentNodeData.nodePtr) {
      this.currentTagCode = this.currentNodeData.name
      this.localTranslation = await this.player.Native.NodeProxy.localTranslation(
        this.currentNodeData.nodePtr
      )
      const quat = await this.player.Native.NodeProxy.localRotation(this.currentNodeData.nodePtr)
      // PlayerUtil公用方法
      this.localRotation = EulerAngle.fromQuat(quat)
      this.localScaling = await this.player.Native.NodeProxy.localScaling(
        this.currentNodeData.nodePtr
      )
      this.commandManage = new CommandManage({
        localTranslation: _.cloneDeep(this.localTranslation),
        localRotation: quat,
        localScaling: _.cloneDeep(this.localScaling),
      })
    }
  },
  beforeDestroy() {
    this.player.Native.NodeEditor.EventEditFinished.disconnect(this.watchEditMsg)
  },
  computed: {
    undoDisable() {
      return _.isNil(this.commandManage) || this.commandManage.executeCount <= 0
    },
    redoDisable() {
      return _.isNil(this.commandManage) || this.commandManage.redoList.length <= 0
    },
    resetDisable() {
      return (
        _.isNil(this.commandManage) ||
        this.commandManage.isReset ||
        this.commandManage.undoList.length <= 0
      )
    },
  },
  methods: {
    // 保存工程数据
    async saveEngineerData() {
      if (this.$route.query.engineerId) {
        if (this.currentNodeData.nodePtr && this.currentTagCode) {
          await this.player.Native.NodeProxy.setNodeInfo(this.currentNodeData.nodePtr, {
            name: this.currentTagCode,
          })
        }
        // 从模型树的上拿到根节点
        const rootItem = await this.player.Native.ModelTree.getRootItems()
        // 在跟节点集合中查找我们设置的场景的跟节点
        const rootNode = _.find(rootItem, (val) => {
          return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Root'
        })
        if (rootNode) {
          const data = await saveSceneToJson(rootNode.nodePtr, this.player)
          this.saveLoading = true
          const res = await DocumentManagementService.getSceneJsonData({
            id: this.$route.query.engineerId,
          })
          if (res && res.code === 0) {
            const params = {
              documentId: this.$route.query.engineerId,
              treeJson: JSON.stringify(data),
            }
            if (res.data && res.data.id) {
              params.id = res.data.id
            }
            const saveRes = await DocumentManagementService.saveSceneJsonData(params)
            if (saveRes && saveRes.code === 0) {
              this.$message.success('保存成功')
              // PlayerUtil公用方法
              const toQuat = EulerAngle.toQuat(this.localRotation)
              this.commandManage.initData = {
                localTranslation: _.cloneDeep(this.localTranslation),
                localRotation: toQuat,
                localScaling: _.cloneDeep(this.localScaling),
              }
              this.commandManage.isReset = true
              this.$emit('updateEditTree', this.currentNodeData.nodePtr)
            } else {
              this.$message.warning(res.message)
            }
          }
          this.saveLoading = false
          console.log(data, 111111)
        }
      }
    },
    // 改变位置
    async changeLocalTranslation() {
      if (this.currentNodeData.nodePtr) {
        if (this.changeTimerOut) {
          clearTimeout(this.changeTimerOut)
        }
        this.changeTimerOut = setTimeout(async () => {
          // PlayerUtil公用方法
          const toQuat = EulerAngle.toQuat(this.localRotation)
          await this.player.Native.NodeProxy.setLocalTranslation(
            this.currentNodeData.nodePtr,
            this.localTranslation
          )
          this.commandManage.executeCommand({
            localTranslation: _.cloneDeep(this.localTranslation),
            localRotation: toQuat,
            localScaling: _.cloneDeep(this.localScaling),
          })
        }, 500)
      }
    },
    // 改变旋转
    async changeLocalRotation() {
      if (this.currentNodeData.nodePtr) {
        if (this.changeTimerOut) {
          clearTimeout(this.changeTimerOut)
        }
        this.changeTimerOut = setTimeout(async () => {
          // PlayerUtil公用方法
          const toQuat = EulerAngle.toQuat(this.localRotation)
          await this.player.Native.NodeProxy.setLocalRotation(this.currentNodeData.nodePtr, toQuat)
          this.commandManage.executeCommand({
            localTranslation: _.cloneDeep(this.localTranslation),
            localRotation: toQuat,
            localScaling: _.cloneDeep(this.localScaling),
          })
        }, 500)
      }
    },
    // 改变缩放
    changeLocalScaling() {
      if (this.currentNodeData.nodePtr) {
        if (this.changeTimerOut) {
          clearTimeout(this.changeTimerOut)
        }
        this.changeTimerOut = setTimeout(async () => {
          // PlayerUtil公用方法
          const toQuat = EulerAngle.toQuat(this.localRotation)
          await this.player.Native.NodeProxy.setLocalScaling(
            this.currentNodeData.nodePtr,
            this.localScaling
          )
          this.commandManage.executeCommand({
            localTranslation: _.cloneDeep(this.localTranslation),
            localRotation: toQuat,
            localScaling: _.cloneDeep(this.localScaling),
          })
        }, 500)
      }
    },
    // 关闭弹框
    async closeComponent() {
      if (this.commandManage && !this.commandManage.isReset) {
        this.$confirm('是否保存模型节点信息？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning',
        })
          .then(async () => {
            this.saveEngineerData()
            await this.player.Native.NodeEditor.setEditType(0)
            this.$emit('closeComponent', 'ModelEditTool')
          })
          .catch(async () => {
            this.resetCommand()
            await this.player.Native.NodeEditor.setEditType(0)
            this.$emit('closeComponent', 'ModelEditTool')
          })
      } else {
        await this.player.Native.NodeEditor.setEditType(0)
        this.$emit('closeComponent', 'ModelEditTool')
      }
    },
    // 设置模型编辑方式
    async setEditType(type) {
      if (!this.currentNodeData.nodePtr) {
        this.$message.warning('请选择编辑节点')
        return
      }
      if (this.editType === type) {
        this.editType = 0
        await this.player.Native.NodeEditor.setEditType(0)
        return
      }
      this.editType = type
      await this.player.Native.NodeEditor.EventEditFinished.disconnect(this.watchEditMsg)
      await this.player.Native.NodeEditor.setNode(this.currentNodeData.nodePtr)
      this.localTranslation = await this.player.Native.NodeProxy.localTranslation(
        this.currentNodeData.nodePtr
      )
      const quat = await this.player.Native.NodeProxy.localRotation(this.currentNodeData.nodePtr)
      // PlayerUtil公用方法
      this.localRotation = EulerAngle.fromQuat(quat)
      this.localScaling = await this.player.Native.NodeProxy.localScaling(
        this.currentNodeData.nodePtr
      )
      await this.player.Native.NodeEditor.setEditType(type)
      this.player.Native.NodeEditor.EventEditFinished.connect(this.watchEditMsg)
    },
    // 撤销
    async undoCommand() {
      const undoData = this.commandManage.undoCommand()
      if (undoData) {
        this.localTranslation = undoData.currentData.localTranslation
        const quat = undoData.currentData.localRotation
        // PlayerUtil公用方法
        this.localRotation = EulerAngle.fromQuat(quat)
        this.localScaling = undoData.currentData.localScaling
        await this.player.Native.NodeProxy.setLocalTranslation(
          this.currentNodeData.nodePtr,
          undoData.currentData.localTranslation
        )
        await this.player.Native.NodeProxy.setLocalRotation(this.currentNodeData.nodePtr, quat)
        await this.player.Native.NodeProxy.setLocalScaling(
          this.currentNodeData.nodePtr,
          undoData.currentData.localScaling
        )
      }
    },
    // 重做
    async redoCommand() {
      const redoData = this.commandManage.redoCommand()
      if (redoData) {
        this.localTranslation = redoData.currentData.localTranslation
        const quat = redoData.currentData.localRotation
        // PlayerUtil公用方法
        this.localRotation = EulerAngle.fromQuat(quat)
        this.localScaling = redoData.currentData.localScaling
        await this.player.Native.NodeProxy.setLocalTranslation(
          this.currentNodeData.nodePtr,
          redoData.currentData.localTranslation
        )
        await this.player.Native.NodeProxy.setLocalRotation(this.currentNodeData.nodePtr, quat)
        await this.player.Native.NodeProxy.setLocalScaling(
          this.currentNodeData.nodePtr,
          redoData.currentData.localScaling
        )
      }
    },
    // 重置
    async resetCommand() {
      const initData = this.commandManage.resetCommand()
      if (initData) {
        this.localTranslation = initData.localTranslation
        const quat = initData.localRotation
        // PlayerUtil公用方法
        this.localRotation = EulerAngle.fromQuat(quat)
        this.localScaling = initData.localScaling
        await this.player.Native.NodeProxy.setLocalTranslation(
          this.currentNodeData.nodePtr,
          initData.localTranslation
        )
        await this.player.Native.NodeProxy.setLocalRotation(this.currentNodeData.nodePtr, quat)
        await this.player.Native.NodeProxy.setLocalScaling(
          this.currentNodeData.nodePtr,
          initData.localScaling
        )
      }
    },
    // 监听编辑结束
    async watchEditMsg(res) {
      this.localTranslation = await this.player.Native.NodeProxy.localTranslation(res.node)
      const quat = await this.player.Native.NodeProxy.localRotation(res.node)
      console.log(quat, 1111)
      // PlayerUtil公用方法
      this.localRotation = EulerAngle.fromQuat(quat)
      console.log(this.localRotation, 1111)
      this.localScaling = await this.player.Native.NodeProxy.localScaling(res.node)
      this.commandManage.executeCommand({
        localTranslation: _.cloneDeep(this.localTranslation),
        localRotation: quat,
        localScaling: _.cloneDeep(this.localScaling),
      })
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/select.scss';
@import '../../css/index.scss';
.model-edit-tool {
  width: 468px;
  right: 35px;
  z-index: 99;
  color: #fff !important;
  padding: 10px;
  border: none;
  background-color: rgba(46, 107, 176, 0.5) !important;
  border: none !important;
}
/deep/.el-card {
  &__body {
    padding: 0 !important;
    height: calc(100% - 60px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}
.card-footer {
  bottom: 10px;
  right: 10px;
  border: none;
}

</style>
